// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const ApkLoanKTAFinancial1Service = {};

ApkLoanKTAFinancial1Service.convertFlatToEffective = function (data) {
  // console.log("🚀 ~ datapostGuarantor:", data);
  return lossClient({
    url: `/ApkLoanKTAFinancial1/convert-flat-to-effective`,
    method: "post",
    headers: {},
    data: data,
  });
};

ApkLoanKTAFinancial1Service.convertEffectiveToFlat = function (data) {
  // console.log("🚀 ~ datapostGuarantor:", data);
  return lossClient({
    url: `/ApkLoanKTAFinancial1/convert-effective-to-flat`,
    method: "post",
    headers: {},
    data: data,
  });
};

ApkLoanKTAFinancial1Service.totalInterestService = function (data) {
  return lossClient({
    url: `/ApkLoanKTAFinancial1/total-interest`,
    method: "post",
    headers: {},
    data: data,
  });
};

ApkLoanKTAFinancial1Service.monthlyInstallmentService = function (data) {
  return lossClient({
    url: `/ApkLoanKTAFinancial1/monthly-installment`,
    method: "post",
    headers: {},
    data: data,
  });
};

ApkLoanKTAFinancial1Service.simulateService = function (data) {
  // console.log("🚀 ~ datapostGuarantor:", data);

  return lossClient({
    url: `/ApkLoanKTAFinancial1/simulate`,
    method: "post",
    headers: {},
    data: data,
  });
};

ApkLoanKTAFinancial1Service.getApkLoanKTAFinancial1Service = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  return lossClient({
    url:
      "/ApkLoanKTAFinancial1/get?pageSize=" +
      data.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&prospectid=" +
      data?.prospectid,
    method: "get",
  });
};

ApkLoanKTAFinancial1Service.putApkLoanKTAFinancial1Service = function (data) {
  return lossClient({
    url: `/ApkLoanKTAFinancial1/edit`,
    method: "put",
    headers: {
      "x-requestId": data.id,
    },
    data: data.data,
  });
};

ApkLoanKTAFinancial1Service.postApkLoanKTAFinancial1Service = function (data) {
  console.log(
    "🚀 ~ file: ApkLoanKTAFinancial1Service.js ~ line 74 ~ data",
    data
  );
  return lossClient({
    url: `/ApkLoanKTAFinancial1/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

ApkLoanKTAFinancial1Service.getEditApkLoanKTAFinancial1Service = function (
  data
) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  return lossClient({
    url:
      "/ApkLoanKTAFinancial1/getEdit?pageSize=" +
      data.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&prospectid=" +
      data?.prospectid,
    method: "get",
  });
};

ApkLoanKTAFinancial1Service.getflatInterestFromInstallment = function (data) {
  return lossClient({
    url:
      "/ApkLoanKTAFinancial1/flat-interest-from-installment?installmentPerMonth=" +
      data?.installmentPerMonth +
      "&principal=" +
      data?.principal +
      "&termMonths=" +
      data?.termMonths,
    method: "get",
  });
};

ApkLoanKTAFinancial1Service.getAddApkLoanKKBFinancial1Service = function (
  data
) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  return lossClient({
    url:
      "/ApkLoanKKBFinancial1/getAdd?pageSize=" +
      data.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&prospectid=" +
      data?.prospectid,
    method: "get",
  });
};


ApkLoanKTAFinancial1Service.posCalculateService = function (data) {
  
  return lossClient({
    url: `/ApkLoanKKBFinancial1/calculate`,
    method: "post",
    headers: {},
    data: data,
  });
};

ApkLoanKTAFinancial1Service.posSimulateService = function (data) {
  
  return lossClient({
    url: `/ApkLoanKKBFinancial1/simulate`,
    method: "post",
    headers: {},
    data: data,
  });
};

ApkLoanKTAFinancial1Service.posAddFinancial1KKBService = function (data) {
  
  return lossClient({
    url: `/ApkLoanKKBFinancial1/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

export default ApkLoanKTAFinancial1Service;
